let currentStep = 0;
let userSelection = [];
let drySelected = false;
let cartItems = [];

const elements = {
    'steps': document.querySelectorAll('.bbv-custom-bundle__step'),
    'actions': document.querySelectorAll('.button[data-action]'),
    'products': document.querySelectorAll('product-card'),
    'addToBundle': document.querySelectorAll('.button[type="submit"]')
}

const SHOPIFY_API = {
    UPDATE: '/cart/update.js',
    ADD: '/cart/add.js'
}

const scrollToOrigin = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

const filterSteps = () => {
    elements.steps.forEach(step => {
        step.style.display = (Number(step.dataset.step) === currentStep) ? 'flex' : 'none';
    });
}

const next = () => {
    if(currentStep < elements.steps.length - 1) {
        currentStep++;
        filterSteps();
        return;
    }

    addToCart();
}

const enableNext = () => {

    const target = elements.steps[currentStep].querySelector('button[data-action="next"]');
    
    if(userSelection[currentStep]) {
        target.removeAttribute('disabled');
        return false;
    }
    
    target.setAttribute('disabled',true);
}

const back = () => {
    if(currentStep > 0) {
        currentStep--;
        filterSteps();
    }
}

const addToBundle = productId => {
    userSelection[currentStep] = productId;
}

const selectProductCard = productId => {

    // reset all products
    elements.products.forEach(product => {
        if(product.dataset.productId !== productId) {

            const button = product.querySelector('button[type="submit"');

            if(!button) {
                return false;
            }

            product.classList.remove('bbv-custom-bundle__added');
            button.dataset.selected = false;
            button.innerHTML = 'Add to bundle';
        }
    })

    // activate or deactivate product
    document.querySelector(`product-card[data-product-id="${productId}"]`).classList.toggle('bbv-custom-bundle__added');
}

const addToCart = () => {

    cartItems = [];

    userSelection.forEach(item => {
        cartItems.push({
            id: item,
            quantity: 1
        });
    });

    // Add bundle product

    /*cartItems.push({
        id: '47028048757068',
        quantity: 1
    });*/

    let formData = {
        'items': cartItems
    }
    
    fetch(SHOPIFY_API.ADD,{ 
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    }).then(response => {
        return response.json();
    }).then(cart => {
        window.location = '/cart';
    })
    .catch(error => {
        console.debug('Find Your Shade:',error);
    });
}

const bindInteraction = () => {

    elements.products.forEach(card => {
        card.onclick = event => {
            document.querySelector(`.button[data-product-id="${event.target.dataset.productId}"]`)?.click();
            return false;
        }
    });

    elements.addToBundle.forEach(button => {
        button.onclick = event => {
            
            const button = event.target;
            const isSelected = button.dataset.selected === 'true';

            if(!isSelected) {
                addToBundle(button.dataset.productId);
                selectProductCard(button.dataset.productId);
                button.dataset.selected = true;
                button.innerHTML = 'Remove from bundle';
                button.style.opacity = .6;
            }
            else {
                addToBundle(undefined);
                selectProductCard(button.dataset.productId);
                button.dataset.selected = false;
                button.innerHTML = 'Add to Bundle';
                button.style.opacity = 1;
            }

            enableNext();
            event.preventDefault();
        }
    });

    elements.actions.forEach(action => {
        action.onclick = event => {
            switch(event.target.dataset.action) {
                case 'next':
                    next();
                    break;
                case 'back':
                    back();
                    break;
            }
            
            scrollToOrigin();

            return false;
        }
    });
}

bindInteraction();